import { createReducer, on } from '@ngrx/store';
import { BaseState, StateManager } from '@app/store/shared/models/base-state';
import { ProfileStatistics } from '../models';
import { profileStatisticsActions } from '../actions/profile-statistics.actions';

export type ProfileStatisticsState = BaseState<ProfileStatistics>;

const initialState: ProfileStatisticsState = StateManager.initial<ProfileStatistics>();

export const profileStatisticsReducer = createReducer(
    initialState,
    on(profileStatisticsActions.getProfileStatistics, (state): ProfileStatisticsState => StateManager.setLoading(state)),
    on(profileStatisticsActions.getProfileStatisticsSuccess, (state, { payload }): ProfileStatisticsState => StateManager.setLoaded(state, payload)),
    on(profileStatisticsActions.getProfileStatisticsError, (state): ProfileStatisticsState => StateManager.setError(state)),
    on(profileStatisticsActions.clear, (): ProfileStatisticsState => initialState),
);
